import React from 'react';
import FailContent from '../components/Common/FailContent';
import { useTranslation } from 'react-i18next';

const PurchaseFail = () => {
  const { t } = useTranslation();

  return (
    <div className={'ml-page'}>
      <div className='layout-inner'>
        <div className='purchase-complete-page-wrapper'>
          <FailContent completeTxt={`${t('purchase_fail')}.`} />
        </div>
      </div>
    </div>
  );
};

export default PurchaseFail;
